export default function setupAppSizeCalculator() {
	function appSize() {
		const doc = document.documentElement;

		const resizeObserver = new ResizeObserver((entries) => {
			for (const entry of entries) {
				const { clientWidth: width, clientHeight: height } = entry.target;
				doc.style.setProperty('--app-width', `${width}px`);
				doc.style.setProperty('--app-height', `${height}px`);
			}
		});

		resizeObserver.observe(doc);
	}
	appSize();
}
